// Autogenerated file
export const universalDocumentSendStatusesEnum = {
    Created: "Created",
    Error: "Error",
    Awaiting: "Awaiting",
    SentToFns: "SentToFns",
    SentToKontur: "SentToKontur",
    SentToEmail: "SentToEmail",
};
export const universalDocumentSendStatuses = [
    { label: "Создан", value: "Created" },
    { label: "Ошибка отправки", value: "Error" },
    { label: "Ожидает отправки", value: "Awaiting" },
    { label: "Отправлен в ФНС", value: "SentToFns" },
    { label: "Отправлен в Диадок", value: "SentToKontur" },
    { label: "Отправлен на E-mail контрагента", value: "SentToEmail" },
];
